import { Button } from '@77sol-ui/atoms'
import styled from 'styled-components'

export const StyledButton = styled(Button)`
  font-size: 0.875rem;
`
